<script>
import Layout from "../../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from '@/components/Page-header';
import appConfig from "../../../../../app.config";


/**
 * Form elements component
 */
export default {
 page: {
    title: "Elementos de protección personal (EPP)",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    PageHeader,
  },
  data() {
    return {
      title: "",
      items: [
        {
          text: "Base de conocimiento",
          href: "/forms/general",
        },
        {
          text: "Elementos de protección personal (EPP)",
          active: true,
        },
      ],
      text: `
          Ad leggings keytar, brunch id art party dolor labore. Pitchfork yr enim lo-fi before they sold out qui. Tumblr farm-to-table bicycle rights whatever. Anim keffiyeh carles cardigan. Velit seitan mcsweeney's photo booth 3 wolf moon irure. Cosby sweater lomo jean shorts, williamsburg hoodie minim qui you probably haven't heard of them et cardigan trust fund culpa biodiesel wes anderson aesthetic. Nihil tattooed accusamus, cred irony biodiesel keffiyeh artisan ullamco consequat.
        `,
      text2: `Labore sit culpa commodo elit adipisicing sit aliquip elit proident voluptate minim mollit nostrud aute reprehenderit do. Mollit excepteur eu Lorem ipsum anim commodo sint labore Lorem in exercitation velit incididunt. Occaecat consectetur nisi in occaecat proident minim enim sunt reprehenderit exercitation cupidatat et do officia. Aliquip consequat ad labore labore mollit ut amet. Sit pariatur tempor proident in veniam culpa aliqua excepteur elit magna fugiat eiusmod amet officia.`,
    };
  },
  methods: {
    /**
     * Scrollspy
     */
    scrollIntoView(evt) {
      evt.preventDefault();
      const href = evt.target.getAttribute("href");
      const el = href ? document.querySelector(href) : null;
      if (el) {
        this.$refs.content.scrollTop = el.offsetTop;
      }
    },
    
  },

};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
  

   
    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-12">
        <div class="card">
          <div class="card-body"> 
            <div class="row">
              <div class="col-6">
                <h4 class="header-title">Elementos de protección personal (EPP)</h4>
              </div>

              <div class="col-6 text-right">
                <a href="/forms/general" class="btn btn-secondary m-l-5 ml-1" id="tooltip">
                  <i class="fas fa-arrow-left"></i>
                </a>
                <b-tooltip target="tooltip" placement="left">Volver</b-tooltip>
              </div>
            </div>

           

            <br>
            <b-row>
              <b-col cols="4">
                <b-list-group v-b-scrollspy:listgroup-ex>
                 <!-- <b-list-group-item href="#list-item-1"
                    >¿QUÉ ES EL COMITÉ COPPASST?</b-list-group-item
                  >-->
                  <b-list-group-item href="#list-item-1"
                    >¿Qué son?</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-2"
                    >¿Cuáles son?</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-3"
                    >Importancia de su uso</b-list-group-item
                  >
                  <b-list-group-item href="#list-item-4"
                    >Obligaciones frente a su uso y cuidado</b-list-group-item
                  >
                     <b-list-group-item href="#list-item-5"
                    >Normas</b-list-group-item
                  >
                <!--  <b-list-group-item href="#list-item-6"
                    >1.1.3</b-list-group-item
                  >-->
                  
                 
                </b-list-group>
              </b-col>

              <b-col cols="8">
                <div
                  id="listgroup-ex"
                  style="position: relative; overflow-y: auto; height: 300px"
                >
                  <!--<h4 id="list-item-1">¿Qué es el comité copasst? </h4>
                  <p>...</p>-->
                  <h4 id="list-item-1">¿Qué son?</h4>
                   <p>“El Elemento de Protección Personal (EPP), es cualquier equipo o dispositivo destinado para ser utilizado o sujetado por el trabajador, para protegerlo de uno o varios riesgos y aumentar su seguridad o su salud en el trabajo”. </p>
                   Ver video  <a href="https://www.youtube.com/watch?v=4ymvWwkMDy0">https://www.youtube.com/watch?v=4ymvWwkMDy0</a><br />
                 
                   <h4 id="list-item-2">¿Cuáles son?</h4>
                   <p>Algunos de los elementos de protección personal que se utilizan en las labores son: <br /> </p >
                           <table class="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>ELEMENTO</th>
                                <th>QUÉ PROTEGE</th>
                                <th>CONDICIONES</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Casco</td>
                                <td>La cabeza de caída de rocas, herramientas o de golpes involuntarios</td>
                                <td>Certificación de calidad con Norma ICONTEC y norma ANSI.
                                Alta resistencia para el tipo de trabajo.
                                Fecha de vencimiento.
                                No conductor de la electricidad.
                                </td>
                              </tr>
                              <tr>
                                <td>Gafas de seguridad</td>
                                <td>Los ojos de la proyección de partículas, exposición a rayos ultravioleta</td>
                                <td>Certificación de calidad con Norma ICONTEC y norma ANSI.
                                  Que sean antiempañantes.
                                  Resistentes a las ralladuras.
                                  Si está expuesto al sol sean anti UV
                                  </td>
                              </tr>
                              <tr>
                                <td>Protección auditiva</td>
                                <td>El sistema auditivo del ruido</td>
                                <td>Certificación de calidad con Norma ICONTEC y norma ANSI.
                                Que efectivamente aísle el ruido ambiental a no más de 85 decibeles a su audición
                                </td>
                              </tr>
                              <tr>
                                <td>Respiradores</td>
                                <td>Las vías respiratorias del polvo y/o gases</td>
                                <td>Certificación de calidad con Norma ICONTEC y norma ANSI.
                                De alta retención de polvo, sobre todo el más fino.
                                Si además de estar expuesto al polvo existen gases presentes utilice filtros para ambos casos (cerciórese del gas o gases a que estará expuesto)
                                </td>
                              </tr>
                              <tr>
                                <td>Guantes</td>
                                <td>Las manos y eventualmente antebrazo (cuando son puños largos) de golpes o exposición a líquidos o sólidos agresivos. Que no se pierda la sensibilidad de la mano, sobre todo para sostener o trabajar con herramientas o materiales</td>
                                <td>Que sean de goma o PVC para manipular o al estar expuesto a líquidos o sólidos agresivos.
                                Que sean de cuero natural para sostener o trabajar con herramientas o materiales.
                                Que sean revestidos con fibra de cerámica u otro material cuando deba trabajar en condiciones de alta temperatura
                                </td>
                              </tr>
                              <tr>
                                <td>Botas</td>
                                <td>Para proteger los pies de golpes.
                                  Para proteger los tobillos de torceduras
                                  </td>
                                <td>Que tengan punta de acero o de fibra.
                                        Que sean de cuero cuando sólo transita en lugares secos, en caso contrario use de goma (botas o cubrecalzado) cerciorándose de que tengan puntas de acero
                                        </td>
                              </tr>
                            </tbody>
                           
                          </table><br /><br />
                          <p>Dependiendo del tipo de trabajo a realizar, se pueden requerir elementos de protección personal adicionales como: </p><br />

                          <table class="table table-bordered table-striped">
                            <thead>
                              <tr>
                                <th>ELEMENTO</th>
                                <th>ACTIVIDAD A REALIZAR</th>
                               
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Arnés, eslinga de posicionamiento, líneas de vida vertical y horizontal, entre otros. </td>
                                <td>Trabajos en alturas</td>
                              </tr>
                              <tr>
                                <td>Traje de soldador (Delantal, mangas, polainas en carnaza y máscara electrónica para soldar)</td>
                                <td>Realice trabajos de soldadura al arco. No se exponga jamás a ver directamente sin protección para su vista estos trabajos</td>
                              </tr>
                              <tr>
                                <td>Traje aluminizado y escafandra</td>
                                <td>Para labores con altas temperaturas</td>
                              </tr>
                              <tr>
                                <td>Auto-rescatador</td>
                                <td>Debe ser usado en situaciones en las cuales haya deficiencia de oxígeno o presencia de gases en las áreas de trabajo. Debe estar en perfecto estado de conservación, sin averías, y que no haya aumentado o disminuido de peso</td>
                              </tr>
                              
                            </tbody>
                           
                          </table><br />


                  <h4 id="list-item-3">Importancia de su uso</h4>
                  <p>Las ventajas de usar los elementos de protección personal (EPP) son las siguientes: <br /> <br /> 
                  Generar una barrera los peligros que hay en las áreas de trabajo y la persona, mayor y mejor protección de la integridad física del trabajador y disminuir la exposición al riesgo que puede desencadenar en una enfermedad laboral, así como, la gravedad de las consecuencias negativas ante un eventual accidente de trabajo. <br /> <br />
                  Por estas razones el uso apropiado de los EPP es de vital importancia, ya que ayudan a proteger la integridad de las personas en el desarrollo de sus actividades laborales, más aún en las diferentes actividades mineras que como se indicó en el inicio del módulo, son actividades no sólo peligrosas, sino que además presentan una alta tasa de accidentalidad. <br /> <br />
                  </p>
                  <h4 id="list-item-4">Obligaciones frente a su uso y cuidado</h4>
                  <p>Código Sustantivo del Trabajo<br /><br />
                  Artículo 56. Es obligación de los empleadores brindar protección y seguridad a sus trabajadores. <br /><br />
                  Ley 9 de Enero 24 de 1979 Código Sanitario (Titulo III SALUD OCUPACIONAL, Artículos 122 a 124) <br /><br />
                  Artículo 122. Todos los empleadores están obligados a proporcionar a cada trabajador, sin costo para éste, elementos de protección personal en cantidad y calidad acordes con los riesgos reales o potenciales existentes en los lugares de trabajo. <br /><br />
                  Artículo 123. Los equipos de protección personal se deben ajustar a las normas oficiales y demás regulaciones técnicas y de seguridad aprobadas por el Gobierno. <br /><br />
                  Artículo 124. El Ministerio de Salud reglamentará la dotación, el uso y la conservación de los equipos de protección personal. <br /><br />
                  Y en la Resolución 2400 de mayo 22 de 1979 Estatuto de Seguridad Industrial (Titulo IV, Capitulo II DE LOS EQUIPOS Y ELEMENTOS DE PROTECCIÓN, Artículos 176 a 201), dispone: <br /><br />
                  •	En todos los establecimientos de trabajo en donde los trabajadores estén expuestos a riesgos físicos, mecánicos, químicos, biológicos, etc, los patronos suministrarán los equipos de protección adecuados, según la naturaleza del riesgo, que reúnan condiciones de seguridad y eficiencia para el usuario. <br />
                  •	En orden a la protección personal de los trabajadores, los patronos estarán obligados a suministrar a éstos los equipos de protección persona. <br />
                  •	La fabricación, calidad, resistencia y duración del equipo de protección suministrado a los trabajadores estará sujeto a las normas aprobadas por la autoridad competente y debe cumplir con los siguientes requisitos: <br /><br />

                  o	Ofrecer adecuada protección contra el riesgo particular para el cual fue diseñado. <br />
                  o	Ser adecuadamente confortable cuando lo usa el trabajador. <br />
                  o	Adaptarse cómodamente sin interferir en los movimientos naturales del usuario. <br />
                  o	Ofrecer garantía de durabilidad. <br />
                  o	Poderse desinfectar y limpiar fácilmente. <br />
                  o	Tener grabada la marca de fábrica para identificar al fabricante, además las características propias del equipo, norma que lo certifica y resistencia, entre otros. <br />
                  <br />
                  </p>
                  <h4  id="list-item-5">Normas</h4>
                  <p> Para garantizar la calidad, idoneidad y resistencia de los elementos de protección personal existen unas normas nacionales e internacionales que certifican que los elementos cumplan con ciertas especificaciones técnicas. <br /> <br />
                  En Colombia existen normas ICONTEC para cada uno de los elementos de protección personal, como por ejemplo los cascos de seguridad que deben estar certificados por la norma ICONTEC 1523. <br /> <br />
                  A nivel internacional existen las normas ANSI (Instituto Americano de Normas) los cuales son estándares industriales voluntarios que establecen los tipos y clases de elementos de protección y fijan requisitos de rendimiento y pruebas para estos elementos de seguridad. Un ejemplo de esta es la ANSI z89.1, que reglamenta los cascos de seguridad. <br /> <br />
                  Los elementos de protección deben contar con un sello que garantice el cumplimiento de estas normas. <br /> <br />
                  Recordamos finalmente, frente a los EPP, que se trata de una responsabilidad compartida, en el sentido en que cada trabajador y contratista está en la obligación de usar adecuadamente los EPP para preservar su vida, pero también cada empleador y contratante tiene el deber no solo de suministrar los EPP apropiados para cada labor, sino, además supervisar y controlar que las personas que están dentro de su empresa u operación utilicen los EPP acorde sea necesario conforme a la actividad o área de labor. <br /> <br />
                  <br /> <br /> <br /> <br /> <br />   </p>
                 <!--  <h4 id="list-item-6">Item 6</h4>
                  <p>{{ text }}</p> 
                  
                  <h4 hidden id="list-item-5"></h4>
                  <p>{{ text }}</p>
                   <h4 hidden id="list-item-6"></h4>
                  <p>{{ text }}</p>-->
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
